export const vibePassTranslations = {
  en: {
    "vibePass.common.noCash": "Vibe Points have no cash value.",
    "vibePass.common.availability": "Subject to venue availability.",
    "vibePass.common.pilotReward": "Pilot reward",
    "vibePass.common.secureEmail": "Open your secure email link.",
    "vibePass.common.scanAtVenue": "Scan at the venue to collect Vibe Points.",
    "vibePass.landing.eyebrow": "Limited controlled pilot | Free to join",
    "vibePass.landing.title": "Eat, drink and save with Vibe Pass",
    "vibePass.landing.intro": "Vibe Pass is entering a limited pilot with selected members, live venue offers, phone alerts, venue QR check-ins, Vibe Points and participating venue rewards.",
    "vibePass.landing.joinBeforeVisit": "Join Vibe Pass before you visit, or scan in when you arrive at a pilot venue.",
    "vibePass.landing.secureLink": "Open your secure email link to access your Vibe Pass.",
    "vibePass.landing.freeAccess": "Free pilot access",
    "vibePass.landing.alreadyMember": "Already an active Vibe Pass member?",
    "vibePass.landing.access": "Access My Vibe Pass",
    "vibePass.landing.activationNote": "Early-access signup may still need activation before the member area opens.",
    "vibePass.landing.joinTitle": "Join the Vibe Pass pilot list",
    "vibePass.landing.joinIntro": "We activate pilot members gradually. This form takes no payment and creates no wallet or member account.",
    "vibePass.landing.firstName": "First name",
    "vibePass.landing.email": "Email address",
    "vibePass.landing.inArea": "Are you currently in Benalmadena?",
    "vibePass.landing.arrival": "Expected arrival date",
    "vibePass.landing.party": "People travelling",
    "vibePass.landing.offerType": "Preferred offer type",
    "vibePass.landing.consent": "I agree to be contacted about the Vibe Pass pilot. No payment is taken today and final pilot terms may apply.",
    "vibePass.landing.joining": "Joining...",
    "vibePass.landing.submit": "Join Free Pilot Access",
    "vibePass.login.eyebrow": "Vibe Pass pilot access",
    "vibePass.login.title": "Access your Vibe Pass",
    "vibePass.login.intro": "Enter your email, open the secure link we send, then complete your venue check-in to collect Vibe Points.",
    "vibePass.login.email": "Email address",
    "vibePass.login.sent": "Secure access email sent",
    "vibePass.login.checkEmail": "Check your email for your Vibe Pass access link.",
    "vibePass.login.return": "Open the email link on this device and we will bring you back to the venue QR check-in.",
    "vibePass.login.spam": "Can't see it? Check spam or junk and use the email registered with Vibe Pass.",
    "vibePass.login.sending": "Sending secure access...",
    "vibePass.login.submit": "Request Secure Access",
    "vibePass.login.error": "We couldn't send your access email. Please ask the venue or try again shortly.",
    "vibePass.login.unconfirmed": "We couldn’t confirm email delivery. Check your inbox and spam folder, then try again if needed.",
    "vibePass.login.back": "Back to Vibe Pass",
    "vibePass.login.explore": "Continue exploring Vibe2Nite",
    "vibePass.checkin.eyebrow": "Vibe Pass venue visit",
    "vibePass.checkin.loadingTitle": "Checking your visit",
    "vibePass.checkin.loading": "Loading this Vibe Pass QR code.",
    "vibePass.checkin.successTitle": "Vibe Points added",
    "vibePass.checkin.success": "You collected {points} Vibe Points for this verified visit at {venue}.",
    "vibePass.checkin.balance": "Updated Vibe Points balance: {balance}",
    "vibePass.checkin.duplicateTitle": "Already checked in",
    "vibePass.checkin.duplicate": "You've already received Vibe Points for this visit.",
    "vibePass.checkin.noExtra": "No extra Vibe Points were added.",
    "vibePass.checkin.loginTitle": "Vibe Pass login needed",
    "vibePass.checkin.login": "Enter your email, open the secure link, then return here to finish check-in.",
    "vibePass.checkin.unavailableTitle": "QR not available",
    "vibePass.checkin.errorTitle": "Check-in unavailable",
    "vibePass.checkin.error": "This Vibe Pass QR code is not currently available. Please ask venue staff for the active QR.",
    "vibePass.checkin.view": "View Vibe Pass",
    "vibePass.checkin.about": "About Vibe Pass",
    "vibePass.checkin.explore": "Explore Vibe2Nite",
    "vibePass.member.yourPass": "Your Vibe Pass",
    "vibePass.member.active": "Active pilot member",
    "vibePass.member.points": "Vibe Points",
    "vibePass.member.usable": "Usable at participating venues",
    "vibePass.member.nextAction": "Your next action",
    "vibePass.member.rewards": "Rewards and progress",
    "vibePass.member.recent": "Recent activity",
    "vibePass.member.liveOffers": "Live offers",
    "vibePass.member.noOffers": "No live offers right now. New participating venue offers will appear here.",
    "vibePass.member.repeatProgress": "Repeat-visit progress",
    "vibePass.member.noActivity": "No Vibe Pass activity yet. Scan a participating venue QR to begin.",
    "vibePass.member.secondary": "Secondary information",
    "vibePass.member.settings": "Settings and help",
    "vibePass.member.membership": "Membership details",
    "vibePass.member.signOut": "Sign out",
    "vibePass.offer.live": "Live now",
    "vibePass.offer.ends": "Ends {date}",
    "vibePass.offer.terms": "Terms: {terms}",
    "vibePass.offer.directions": "Directions",
    "vibePass.alerts.title": "Get Vibe Alerts",
    "vibePass.alerts.intro": "Get real-time alerts when participating venues launch live offers and rewards.",
    "vibePass.alerts.destination": "Destination",
    "vibePass.alerts.active": "Vibe Alerts are ON for this browser.",
    "vibePass.alerts.available": "Vibe Alerts are available. Enable them to receive live offer notifications.",
    "vibePass.alerts.blocked": "Notifications are blocked in your browser settings.",
    "vibePass.alerts.unsupported": "Vibe Alerts are not supported on this browser or device.",
    "vibePass.alerts.ios": "Add Vibe2Nite to your Home Screen to enable Vibe Alerts on iPhone.",
    "vibePass.alerts.enable": "Enable Vibe Alerts",
    "vibePass.alerts.enabled": "Alerts Enabled",
    "vibePass.alerts.save": "Save Preferences",
    "vibePass.alerts.off": "Turn Off Alerts"
  },
  es: {
    "vibePass.common.noCash": "Los Vibe Points no tienen valor en efectivo.",
    "vibePass.common.availability": "Sujeto a disponibilidad del establecimiento.",
    "vibePass.common.pilotReward": "Recompensa piloto",
    "vibePass.common.secureEmail": "Abre el enlace seguro de tu correo electrónico.",
    "vibePass.common.scanAtVenue": "Escanea en el establecimiento para conseguir Vibe Points.",
    "vibePass.landing.eyebrow": "Piloto limitado y controlado | Únete gratis",
    "vibePass.landing.title": "Come, bebe y ahorra con Vibe Pass",
    "vibePass.landing.intro": "Vibe Pass inicia un piloto limitado con ofertas en directo, alertas, registros QR, Vibe Points y recompensas en establecimientos participantes.",
    "vibePass.landing.joinBeforeVisit": "Únete a Vibe Pass antes de tu visita o escanea al llegar a un establecimiento piloto.",
    "vibePass.landing.secureLink": "Abre el enlace seguro de tu correo para acceder a Vibe Pass.",
    "vibePass.landing.freeAccess": "Acceso piloto gratuito",
    "vibePass.landing.alreadyMember": "¿Ya eres miembro activo de Vibe Pass?",
    "vibePass.landing.access": "Acceder a mi Vibe Pass",
    "vibePass.landing.activationNote": "El registro anticipado puede necesitar activación antes de abrir el área de miembros.",
    "vibePass.landing.joinTitle": "Únete a la lista piloto de Vibe Pass",
    "vibePass.landing.joinIntro": "Activamos miembros gradualmente. Este formulario no cobra ni crea monedero o cuenta de miembro.",
    "vibePass.landing.firstName": "Nombre",
    "vibePass.landing.email": "Correo electrónico",
    "vibePass.landing.inArea": "¿Estás ahora en Benalmádena?",
    "vibePass.landing.arrival": "Fecha prevista de llegada",
    "vibePass.landing.party": "Personas que viajan",
    "vibePass.landing.offerType": "Tipo de oferta preferida",
    "vibePass.landing.consent": "Acepto recibir información sobre el piloto Vibe Pass. Hoy no se realiza ningún pago y pueden aplicarse condiciones finales.",
    "vibePass.landing.joining": "Uniéndote...",
    "vibePass.landing.submit": "Unirme gratis al piloto",
    "vibePass.login.eyebrow": "Acceso piloto Vibe Pass",
    "vibePass.login.title": "Accede a tu Vibe Pass",
    "vibePass.login.intro": "Introduce tu correo, abre el enlace seguro que enviamos y completa el registro en el establecimiento para conseguir Vibe Points.",
    "vibePass.login.email": "Correo electrónico",
    "vibePass.login.sent": "Correo de acceso seguro enviado",
    "vibePass.login.checkEmail": "Revisa tu correo para encontrar el enlace de acceso a Vibe Pass.",
    "vibePass.login.return": "Abre el enlace en este dispositivo y volverás al registro QR del establecimiento.",
    "vibePass.login.spam": "¿No lo ves? Revisa spam y usa el correo registrado en Vibe Pass.",
    "vibePass.login.sending": "Enviando acceso seguro...",
    "vibePass.login.submit": "Solicitar acceso seguro",
    "vibePass.login.error": "No pudimos enviar el correo de acceso. Pregunta al establecimiento o inténtalo de nuevo.",
    "vibePass.login.unconfirmed": "No hemos podido confirmar el envío. Revisa tu bandeja de entrada y la carpeta de spam antes de volver a intentarlo.",
    "vibePass.login.back": "Volver a Vibe Pass",
    "vibePass.login.explore": "Seguir explorando Vibe2Nite",
    "vibePass.checkin.eyebrow": "Visita Vibe Pass",
    "vibePass.checkin.loadingTitle": "Comprobando tu visita",
    "vibePass.checkin.loading": "Cargando este código QR de Vibe Pass.",
    "vibePass.checkin.successTitle": "Vibe Points añadidos",
    "vibePass.checkin.success": "Has conseguido {points} Vibe Points por esta visita verificada a {venue}.",
    "vibePass.checkin.balance": "Saldo actualizado de Vibe Points: {balance}",
    "vibePass.checkin.duplicateTitle": "Ya has registrado la visita",
    "vibePass.checkin.duplicate": "Ya has recibido Vibe Points por esta visita.",
    "vibePass.checkin.noExtra": "No se añadieron Vibe Points adicionales.",
    "vibePass.checkin.loginTitle": "Necesitas acceder a Vibe Pass",
    "vibePass.checkin.login": "Introduce tu correo, abre el enlace seguro y vuelve aquí para terminar el registro.",
    "vibePass.checkin.unavailableTitle": "QR no disponible",
    "vibePass.checkin.errorTitle": "Registro no disponible",
    "vibePass.checkin.error": "Este QR de Vibe Pass no está disponible. Pide al personal el QR activo.",
    "vibePass.checkin.view": "Ver Vibe Pass",
    "vibePass.checkin.about": "Acerca de Vibe Pass",
    "vibePass.checkin.explore": "Explorar Vibe2Nite",
    "vibePass.member.yourPass": "Tu Vibe Pass",
    "vibePass.member.active": "Miembro piloto activo",
    "vibePass.member.points": "Vibe Points",
    "vibePass.member.usable": "Utilizables en establecimientos participantes",
    "vibePass.member.nextAction": "Tu siguiente acción",
    "vibePass.member.rewards": "Recompensas y progreso",
    "vibePass.member.recent": "Actividad reciente",
    "vibePass.member.liveOffers": "Ofertas en directo",
    "vibePass.member.noOffers": "No hay ofertas en directo ahora. Las nuevas ofertas aparecerán aquí.",
    "vibePass.member.repeatProgress": "Progreso de visitas repetidas",
    "vibePass.member.noActivity": "Aún no hay actividad. Escanea el QR de un establecimiento participante para empezar.",
    "vibePass.member.secondary": "Información secundaria",
    "vibePass.member.settings": "Ajustes y ayuda",
    "vibePass.member.membership": "Detalles de membresía",
    "vibePass.member.signOut": "Cerrar sesión",
    "vibePass.offer.live": "En directo",
    "vibePass.offer.ends": "Termina {date}",
    "vibePass.offer.terms": "Condiciones: {terms}",
    "vibePass.offer.directions": "Cómo llegar",
    "vibePass.alerts.title": "Recibe Vibe Alerts",
    "vibePass.alerts.intro": "Recibe alertas cuando los establecimientos publiquen ofertas y recompensas.",
    "vibePass.alerts.destination": "Destino",
    "vibePass.alerts.active": "Vibe Alerts están ACTIVADAS en este navegador.",
    "vibePass.alerts.available": "Vibe Alerts están disponibles. Actívalas para recibir ofertas.",
    "vibePass.alerts.blocked": "Las notificaciones están bloqueadas en los ajustes del navegador.",
    "vibePass.alerts.unsupported": "Vibe Alerts no son compatibles con este navegador o dispositivo.",
    "vibePass.alerts.ios": "Añade Vibe2Nite a la pantalla de inicio para activar Vibe Alerts en iPhone.",
    "vibePass.alerts.enable": "Activar Vibe Alerts",
    "vibePass.alerts.enabled": "Alertas activadas",
    "vibePass.alerts.save": "Guardar preferencias",
    "vibePass.alerts.off": "Desactivar alertas"
  },
  de: {
    "vibePass.common.noCash": "Vibe Points haben keinen Barwert.",
    "vibePass.common.availability": "Je nach Verfügbarkeit im teilnehmenden Betrieb.",
    "vibePass.common.pilotReward": "Pilotprämie",
    "vibePass.common.secureEmail": "Öffne den sicheren Link in deiner E-Mail.",
    "vibePass.common.scanAtVenue": "Scanne vor Ort, um Vibe Points zu sammeln.",
    "vibePass.landing.eyebrow": "Begrenzter Testbetrieb | Kostenlos anmelden",
    "vibePass.landing.title": "Essen, trinken und sparen mit Vibe Pass",
    "vibePass.landing.intro": "Vibe Pass startet einen begrenzten Test mit Live-Angeboten, Benachrichtigungen, QR-Check-ins, Vibe Points und Prämien teilnehmender Betriebe.",
    "vibePass.landing.joinBeforeVisit": "Melde dich vor dem Besuch an oder scanne bei deiner Ankunft in einem Pilotbetrieb.",
    "vibePass.landing.secureLink": "Öffne den sicheren E-Mail-Link, um auf deinen Vibe Pass zuzugreifen.",
    "vibePass.landing.freeAccess": "Kostenloser Pilotzugang",
    "vibePass.landing.alreadyMember": "Bereits aktives Vibe Pass Mitglied?",
    "vibePass.landing.access": "Meinen Vibe Pass öffnen",
    "vibePass.landing.activationNote": "Die frühe Anmeldung muss möglicherweise aktiviert werden, bevor der Mitgliederbereich geöffnet wird.",
    "vibePass.landing.joinTitle": "Für den Vibe Pass Pilot anmelden",
    "vibePass.landing.joinIntro": "Mitglieder werden schrittweise aktiviert. Dieses Formular nimmt keine Zahlung vor und erstellt kein Punktekonto.",
    "vibePass.landing.firstName": "Vorname",
    "vibePass.landing.email": "E-Mail-Adresse",
    "vibePass.landing.inArea": "Bist du derzeit in Benalmádena?",
    "vibePass.landing.arrival": "Voraussichtliche Ankunft",
    "vibePass.landing.party": "Reisende Personen",
    "vibePass.landing.offerType": "Bevorzugtes Angebot",
    "vibePass.landing.consent": "Ich stimme Informationen zum Vibe Pass Pilot zu. Heute erfolgt keine Zahlung; endgültige Bedingungen können gelten.",
    "vibePass.landing.joining": "Anmeldung läuft...",
    "vibePass.landing.submit": "Kostenlos teilnehmen",
    "vibePass.login.eyebrow": "Vibe Pass Pilotzugang",
    "vibePass.login.title": "Vibe Pass öffnen",
    "vibePass.login.intro": "E-Mail eingeben, sicheren Link öffnen und den Check-in vor Ort abschließen, um Vibe Points zu sammeln.",
    "vibePass.login.email": "E-Mail-Adresse",
    "vibePass.login.sent": "Sichere Zugangs-E-Mail gesendet",
    "vibePass.login.checkEmail": "Prüfe deine E-Mails auf den Vibe Pass Zugangslink.",
    "vibePass.login.return": "Öffne den Link auf diesem Gerät. Danach kehrst du zum QR-Check-in zurück.",
    "vibePass.login.spam": "Nicht sichtbar? Prüfe den Spamordner und nutze deine registrierte E-Mail.",
    "vibePass.login.sending": "Sicherer Zugang wird gesendet...",
    "vibePass.login.submit": "Sicheren Zugang anfordern",
    "vibePass.login.error": "Die Zugangs-E-Mail konnte nicht gesendet werden. Bitte erneut versuchen oder den Betrieb fragen.",
    "vibePass.login.unconfirmed": "Der E-Mail-Versand konnte nicht bestätigt werden. Prüfe deinen Posteingang und Spamordner, bevor du es erneut versuchst.",
    "vibePass.login.back": "Zurück zu Vibe Pass",
    "vibePass.login.explore": "Vibe2Nite weiter entdecken",
    "vibePass.checkin.eyebrow": "Vibe Pass Besuch",
    "vibePass.checkin.loadingTitle": "Besuch wird geprüft",
    "vibePass.checkin.loading": "Dieser Vibe Pass QR-Code wird geladen.",
    "vibePass.checkin.successTitle": "Vibe Points hinzugefügt",
    "vibePass.checkin.success": "Du hast {points} Vibe Points für deinen bestätigten Besuch bei {venue} gesammelt.",
    "vibePass.checkin.balance": "Aktueller Vibe Points Stand: {balance}",
    "vibePass.checkin.duplicateTitle": "Bereits eingecheckt",
    "vibePass.checkin.duplicate": "Für diesen Besuch hast du bereits Vibe Points erhalten.",
    "vibePass.checkin.noExtra": "Es wurden keine weiteren Vibe Points hinzugefügt.",
    "vibePass.checkin.loginTitle": "Vibe Pass Anmeldung erforderlich",
    "vibePass.checkin.login": "E-Mail eingeben, sicheren Link öffnen und hierher zurückkehren, um den Check-in abzuschließen.",
    "vibePass.checkin.unavailableTitle": "QR nicht verfügbar",
    "vibePass.checkin.errorTitle": "Check-in nicht verfügbar",
    "vibePass.checkin.error": "Dieser Vibe Pass QR-Code ist derzeit nicht verfügbar. Bitte frage nach dem aktiven QR-Code.",
    "vibePass.checkin.view": "Vibe Pass anzeigen",
    "vibePass.checkin.about": "Über Vibe Pass",
    "vibePass.checkin.explore": "Vibe2Nite entdecken",
    "vibePass.member.yourPass": "Dein Vibe Pass",
    "vibePass.member.active": "Aktives Pilotmitglied",
    "vibePass.member.points": "Vibe Points",
    "vibePass.member.usable": "Bei teilnehmenden Betrieben nutzbar",
    "vibePass.member.nextAction": "Dein nächster Schritt",
    "vibePass.member.rewards": "Prämien und Fortschritt",
    "vibePass.member.recent": "Letzte Aktivitäten",
    "vibePass.member.liveOffers": "Live-Angebote",
    "vibePass.member.noOffers": "Derzeit keine Live-Angebote. Neue Angebote erscheinen hier.",
    "vibePass.member.repeatProgress": "Fortschritt bei Folgebesuchen",
    "vibePass.member.noActivity": "Noch keine Aktivität. Scanne zum Start den QR-Code eines teilnehmenden Betriebs.",
    "vibePass.member.secondary": "Weitere Informationen",
    "vibePass.member.settings": "Einstellungen und Hilfe",
    "vibePass.member.membership": "Mitgliedschaft",
    "vibePass.member.signOut": "Abmelden",
    "vibePass.offer.live": "Jetzt live",
    "vibePass.offer.ends": "Endet {date}",
    "vibePass.offer.terms": "Bedingungen: {terms}",
    "vibePass.offer.directions": "Route",
    "vibePass.alerts.title": "Vibe Alerts erhalten",
    "vibePass.alerts.intro": "Erhalte Benachrichtigungen zu Angeboten und Prämien teilnehmender Betriebe.",
    "vibePass.alerts.destination": "Reiseziel",
    "vibePass.alerts.active": "Vibe Alerts sind in diesem Browser AKTIV.",
    "vibePass.alerts.available": "Vibe Alerts sind verfügbar. Aktiviere sie für Live-Angebote.",
    "vibePass.alerts.blocked": "Benachrichtigungen sind in den Browser-Einstellungen blockiert.",
    "vibePass.alerts.unsupported": "Vibe Alerts werden auf diesem Browser oder Gerät nicht unterstützt.",
    "vibePass.alerts.ios": "Füge Vibe2Nite zum Home-Bildschirm hinzu, um Vibe Alerts auf dem iPhone zu aktivieren.",
    "vibePass.alerts.enable": "Vibe Alerts aktivieren",
    "vibePass.alerts.enabled": "Alerts aktiviert",
    "vibePass.alerts.save": "Einstellungen speichern",
    "vibePass.alerts.off": "Alerts ausschalten"
  },
  nl: {
    "vibePass.common.noCash": "Vibe Points hebben geen contante waarde.",
    "vibePass.common.availability": "Afhankelijk van beschikbaarheid bij de locatie.",
    "vibePass.common.pilotReward": "Pilotbeloning",
    "vibePass.common.secureEmail": "Open de beveiligde link in je e-mail.",
    "vibePass.common.scanAtVenue": "Scan op de locatie om Vibe Points te verzamelen.",
    "vibePass.landing.eyebrow": "Beperkte gecontroleerde pilot | Gratis aanmelden",
    "vibePass.landing.title": "Eet, drink en bespaar met Vibe Pass",
    "vibePass.landing.intro": "Vibe Pass start een beperkte pilot met live aanbiedingen, meldingen, QR-check-ins, Vibe Points en beloningen van deelnemende locaties.",
    "vibePass.landing.joinBeforeVisit": "Meld je aan vóór je bezoek of scan bij aankomst op een pilotlocatie.",
    "vibePass.landing.secureLink": "Open de beveiligde e-maillink om je Vibe Pass te bekijken.",
    "vibePass.landing.freeAccess": "Gratis pilottoegang",
    "vibePass.landing.alreadyMember": "Al een actief Vibe Pass-lid?",
    "vibePass.landing.access": "Mijn Vibe Pass openen",
    "vibePass.landing.activationNote": "Vroege aanmelding moet mogelijk nog worden geactiveerd voordat het ledengedeelte opent.",
    "vibePass.landing.joinTitle": "Meld je aan voor de Vibe Pass-pilot",
    "vibePass.landing.joinIntro": "Leden worden geleidelijk geactiveerd. Dit formulier neemt geen betaling aan en maakt geen wallet of ledenaccount.",
    "vibePass.landing.firstName": "Voornaam",
    "vibePass.landing.email": "E-mailadres",
    "vibePass.landing.inArea": "Ben je nu in Benalmádena?",
    "vibePass.landing.arrival": "Verwachte aankomstdatum",
    "vibePass.landing.party": "Aantal reizigers",
    "vibePass.landing.offerType": "Voorkeur voor aanbieding",
    "vibePass.landing.consent": "Ik ga akkoord met informatie over de Vibe Pass-pilot. Vandaag wordt niets betaald en definitieve voorwaarden kunnen gelden.",
    "vibePass.landing.joining": "Aanmelden...",
    "vibePass.landing.submit": "Gratis deelnemen",
    "vibePass.login.eyebrow": "Vibe Pass-pilottoegang",
    "vibePass.login.title": "Open je Vibe Pass",
    "vibePass.login.intro": "Vul je e-mail in, open de beveiligde link en rond de check-in op locatie af om Vibe Points te verzamelen.",
    "vibePass.login.email": "E-mailadres",
    "vibePass.login.sent": "Beveiligde toegangsmail verzonden",
    "vibePass.login.checkEmail": "Controleer je e-mail voor de Vibe Pass-toegangslink.",
    "vibePass.login.return": "Open de link op dit apparaat. Je keert daarna terug naar de QR-check-in.",
    "vibePass.login.spam": "Niet ontvangen? Controleer spam en gebruik je geregistreerde e-mailadres.",
    "vibePass.login.sending": "Beveiligde toegang verzenden...",
    "vibePass.login.submit": "Beveiligde toegang aanvragen",
    "vibePass.login.error": "We konden de toegangsmail niet sturen. Vraag de locatie of probeer het opnieuw.",
    "vibePass.login.unconfirmed": "We konden de verzending niet bevestigen. Controleer je inbox en spammap voordat je het opnieuw probeert.",
    "vibePass.login.back": "Terug naar Vibe Pass",
    "vibePass.login.explore": "Vibe2Nite verder ontdekken",
    "vibePass.checkin.eyebrow": "Vibe Pass-bezoek",
    "vibePass.checkin.loadingTitle": "Je bezoek controleren",
    "vibePass.checkin.loading": "Deze Vibe Pass-QR-code laden.",
    "vibePass.checkin.successTitle": "Vibe Points toegevoegd",
    "vibePass.checkin.success": "Je hebt {points} Vibe Points verzameld voor je geverifieerde bezoek aan {venue}.",
    "vibePass.checkin.balance": "Bijgewerkt Vibe Points-saldo: {balance}",
    "vibePass.checkin.duplicateTitle": "Al ingecheckt",
    "vibePass.checkin.duplicate": "Je hebt al Vibe Points voor dit bezoek ontvangen.",
    "vibePass.checkin.noExtra": "Er zijn geen extra Vibe Points toegevoegd.",
    "vibePass.checkin.loginTitle": "Vibe Pass-login nodig",
    "vibePass.checkin.login": "Vul je e-mail in, open de beveiligde link en kom terug om de check-in af te ronden.",
    "vibePass.checkin.unavailableTitle": "QR niet beschikbaar",
    "vibePass.checkin.errorTitle": "Check-in niet beschikbaar",
    "vibePass.checkin.error": "Deze Vibe Pass-QR-code is niet beschikbaar. Vraag het personeel om de actieve QR.",
    "vibePass.checkin.view": "Vibe Pass bekijken",
    "vibePass.checkin.about": "Over Vibe Pass",
    "vibePass.checkin.explore": "Vibe2Nite ontdekken",
    "vibePass.member.yourPass": "Jouw Vibe Pass",
    "vibePass.member.active": "Actief pilotlid",
    "vibePass.member.points": "Vibe Points",
    "vibePass.member.usable": "Te gebruiken bij deelnemende locaties",
    "vibePass.member.nextAction": "Je volgende stap",
    "vibePass.member.rewards": "Beloningen en voortgang",
    "vibePass.member.recent": "Recente activiteit",
    "vibePass.member.liveOffers": "Live aanbiedingen",
    "vibePass.member.noOffers": "Nu geen live aanbiedingen. Nieuwe aanbiedingen verschijnen hier.",
    "vibePass.member.repeatProgress": "Voortgang bij herhaalbezoeken",
    "vibePass.member.noActivity": "Nog geen activiteit. Scan een QR bij een deelnemende locatie om te beginnen.",
    "vibePass.member.secondary": "Aanvullende informatie",
    "vibePass.member.settings": "Instellingen en hulp",
    "vibePass.member.membership": "Lidmaatschapsgegevens",
    "vibePass.member.signOut": "Uitloggen",
    "vibePass.offer.live": "Nu live",
    "vibePass.offer.ends": "Eindigt {date}",
    "vibePass.offer.terms": "Voorwaarden: {terms}",
    "vibePass.offer.directions": "Route",
    "vibePass.alerts.title": "Ontvang Vibe Alerts",
    "vibePass.alerts.intro": "Ontvang meldingen over live aanbiedingen en beloningen van deelnemende locaties.",
    "vibePass.alerts.destination": "Bestemming",
    "vibePass.alerts.active": "Vibe Alerts staan AAN in deze browser.",
    "vibePass.alerts.available": "Vibe Alerts zijn beschikbaar. Schakel ze in voor live aanbiedingen.",
    "vibePass.alerts.blocked": "Meldingen zijn geblokkeerd in je browserinstellingen.",
    "vibePass.alerts.unsupported": "Vibe Alerts worden niet ondersteund op deze browser of dit apparaat.",
    "vibePass.alerts.ios": "Voeg Vibe2Nite toe aan je beginscherm om Vibe Alerts op iPhone te activeren.",
    "vibePass.alerts.enable": "Vibe Alerts inschakelen",
    "vibePass.alerts.enabled": "Alerts ingeschakeld",
    "vibePass.alerts.save": "Voorkeuren opslaan",
    "vibePass.alerts.off": "Alerts uitschakelen"
  },
  fr: {
    "vibePass.common.noCash": "Les Vibe Points n'ont aucune valeur monétaire.",
    "vibePass.common.availability": "Sous réserve de disponibilité dans l'établissement.",
    "vibePass.common.pilotReward": "Récompense pilote",
    "vibePass.common.secureEmail": "Ouvrez le lien sécurisé reçu par e-mail.",
    "vibePass.common.scanAtVenue": "Scannez sur place pour obtenir des Vibe Points.",
    "vibePass.landing.eyebrow": "Pilote limité et contrôlé | Inscription gratuite",
    "vibePass.landing.title": "Mangez, buvez et économisez avec Vibe Pass",
    "vibePass.landing.intro": "Vibe Pass lance un pilote limité avec offres en direct, alertes, check-ins QR, Vibe Points et récompenses des établissements participants.",
    "vibePass.landing.joinBeforeVisit": "Inscrivez-vous avant votre visite ou scannez à votre arrivée dans un établissement pilote.",
    "vibePass.landing.secureLink": "Ouvrez le lien sécurisé reçu par e-mail pour accéder à Vibe Pass.",
    "vibePass.landing.freeAccess": "Accès pilote gratuit",
    "vibePass.landing.alreadyMember": "Déjà membre actif de Vibe Pass ?",
    "vibePass.landing.access": "Accéder à mon Vibe Pass",
    "vibePass.landing.activationNote": "L'inscription anticipée peut nécessiter une activation avant l'ouverture de l'espace membre.",
    "vibePass.landing.joinTitle": "Rejoignez le pilote Vibe Pass",
    "vibePass.landing.joinIntro": "Les membres sont activés progressivement. Ce formulaire ne prélève aucun paiement et ne crée aucun portefeuille.",
    "vibePass.landing.firstName": "Prénom",
    "vibePass.landing.email": "Adresse e-mail",
    "vibePass.landing.inArea": "Êtes-vous actuellement à Benalmádena ?",
    "vibePass.landing.arrival": "Date d'arrivée prévue",
    "vibePass.landing.party": "Nombre de voyageurs",
    "vibePass.landing.offerType": "Type d'offre préféré",
    "vibePass.landing.consent": "J'accepte d'être contacté au sujet du pilote Vibe Pass. Aucun paiement n'est effectué aujourd'hui et des conditions finales peuvent s'appliquer.",
    "vibePass.landing.joining": "Inscription...",
    "vibePass.landing.submit": "Rejoindre gratuitement",
    "vibePass.login.eyebrow": "Accès pilote Vibe Pass",
    "vibePass.login.title": "Accédez à votre Vibe Pass",
    "vibePass.login.intro": "Saisissez votre e-mail, ouvrez le lien sécurisé puis terminez le check-in sur place pour obtenir des Vibe Points.",
    "vibePass.login.email": "Adresse e-mail",
    "vibePass.login.sent": "E-mail d'accès sécurisé envoyé",
    "vibePass.login.checkEmail": "Consultez votre e-mail pour trouver le lien d'accès Vibe Pass.",
    "vibePass.login.return": "Ouvrez le lien sur cet appareil : vous reviendrez au check-in QR.",
    "vibePass.login.spam": "Vous ne le voyez pas ? Consultez les courriers indésirables et utilisez l'e-mail enregistré.",
    "vibePass.login.sending": "Envoi de l'accès sécurisé...",
    "vibePass.login.submit": "Demander un accès sécurisé",
    "vibePass.login.error": "Impossible d'envoyer l'e-mail d'accès. Demandez à l'établissement ou réessayez.",
    "vibePass.login.unconfirmed": "Nous n’avons pas pu confirmer l’envoi. Vérifiez votre boîte de réception et vos courriers indésirables avant de réessayer.",
    "vibePass.login.back": "Retour à Vibe Pass",
    "vibePass.login.explore": "Continuer à explorer Vibe2Nite",
    "vibePass.checkin.eyebrow": "Visite Vibe Pass",
    "vibePass.checkin.loadingTitle": "Vérification de votre visite",
    "vibePass.checkin.loading": "Chargement de ce QR Vibe Pass.",
    "vibePass.checkin.successTitle": "Vibe Points ajoutés",
    "vibePass.checkin.success": "Vous avez obtenu {points} Vibe Points pour cette visite vérifiée chez {venue}.",
    "vibePass.checkin.balance": "Solde Vibe Points mis à jour : {balance}",
    "vibePass.checkin.duplicateTitle": "Check-in déjà effectué",
    "vibePass.checkin.duplicate": "Vous avez déjà reçu des Vibe Points pour cette visite.",
    "vibePass.checkin.noExtra": "Aucun Vibe Point supplémentaire n'a été ajouté.",
    "vibePass.checkin.loginTitle": "Connexion Vibe Pass requise",
    "vibePass.checkin.login": "Saisissez votre e-mail, ouvrez le lien sécurisé puis revenez terminer le check-in.",
    "vibePass.checkin.unavailableTitle": "QR indisponible",
    "vibePass.checkin.errorTitle": "Check-in indisponible",
    "vibePass.checkin.error": "Ce QR Vibe Pass n'est pas disponible. Demandez au personnel le QR actif.",
    "vibePass.checkin.view": "Voir Vibe Pass",
    "vibePass.checkin.about": "À propos de Vibe Pass",
    "vibePass.checkin.explore": "Explorer Vibe2Nite",
    "vibePass.member.yourPass": "Votre Vibe Pass",
    "vibePass.member.active": "Membre pilote actif",
    "vibePass.member.points": "Vibe Points",
    "vibePass.member.usable": "Utilisables dans les établissements participants",
    "vibePass.member.nextAction": "Votre prochaine étape",
    "vibePass.member.rewards": "Récompenses et progression",
    "vibePass.member.recent": "Activité récente",
    "vibePass.member.liveOffers": "Offres en direct",
    "vibePass.member.noOffers": "Aucune offre en direct actuellement. Les nouvelles offres apparaîtront ici.",
    "vibePass.member.repeatProgress": "Progression des visites",
    "vibePass.member.noActivity": "Aucune activité pour le moment. Scannez le QR d'un établissement participant.",
    "vibePass.member.secondary": "Informations secondaires",
    "vibePass.member.settings": "Réglages et aide",
    "vibePass.member.membership": "Détails de l'adhésion",
    "vibePass.member.signOut": "Se déconnecter",
    "vibePass.offer.live": "En direct",
    "vibePass.offer.ends": "Se termine {date}",
    "vibePass.offer.terms": "Conditions : {terms}",
    "vibePass.offer.directions": "Itinéraire",
    "vibePass.alerts.title": "Recevoir les Vibe Alerts",
    "vibePass.alerts.intro": "Recevez des alertes pour les offres et récompenses des établissements participants.",
    "vibePass.alerts.destination": "Destination",
    "vibePass.alerts.active": "Les Vibe Alerts sont ACTIVÉES dans ce navigateur.",
    "vibePass.alerts.available": "Les Vibe Alerts sont disponibles. Activez-les pour recevoir les offres.",
    "vibePass.alerts.blocked": "Les notifications sont bloquées dans les réglages du navigateur.",
    "vibePass.alerts.unsupported": "Les Vibe Alerts ne sont pas compatibles avec ce navigateur ou appareil.",
    "vibePass.alerts.ios": "Ajoutez Vibe2Nite à l'écran d'accueil pour activer les Vibe Alerts sur iPhone.",
    "vibePass.alerts.enable": "Activer les Vibe Alerts",
    "vibePass.alerts.enabled": "Alertes activées",
    "vibePass.alerts.save": "Enregistrer les préférences",
    "vibePass.alerts.off": "Désactiver les alertes"
  },
  sv: {
    "vibePass.common.noCash": "Vibe Points har inget kontantvärde.",
    "vibePass.common.availability": "I mån av tillgänglighet på platsen.",
    "vibePass.common.pilotReward": "Pilotbelöning",
    "vibePass.common.secureEmail": "Öppna den säkra länken i ditt e-postmeddelande.",
    "vibePass.common.scanAtVenue": "Skanna på plats för att samla Vibe Points.",
    "vibePass.landing.eyebrow": "Begränsad kontrollerad pilot | Gratis att gå med",
    "vibePass.landing.title": "Ät, drick och spara med Vibe Pass",
    "vibePass.landing.intro": "Vibe Pass startar en begränsad pilot med liveerbjudanden, aviseringar, QR-incheckningar, Vibe Points och belöningar hos deltagande platser.",
    "vibePass.landing.joinBeforeVisit": "Gå med före besöket eller skanna när du kommer till en pilotplats.",
    "vibePass.landing.secureLink": "Öppna den säkra e-postlänken för att komma åt ditt Vibe Pass.",
    "vibePass.landing.freeAccess": "Gratis pilotåtkomst",
    "vibePass.landing.alreadyMember": "Redan aktiv Vibe Pass-medlem?",
    "vibePass.landing.access": "Öppna mitt Vibe Pass",
    "vibePass.landing.activationNote": "Tidig registrering kan behöva aktiveras innan medlemsområdet öppnas.",
    "vibePass.landing.joinTitle": "Gå med i Vibe Pass-piloten",
    "vibePass.landing.joinIntro": "Medlemmar aktiveras stegvis. Formuläret tar ingen betalning och skapar ingen plånbok eller medlemsprofil.",
    "vibePass.landing.firstName": "Förnamn",
    "vibePass.landing.email": "E-postadress",
    "vibePass.landing.inArea": "Är du i Benalmádena nu?",
    "vibePass.landing.arrival": "Förväntat ankomstdatum",
    "vibePass.landing.party": "Antal resenärer",
    "vibePass.landing.offerType": "Önskad erbjudandetyp",
    "vibePass.landing.consent": "Jag godkänner kontakt om Vibe Pass-piloten. Ingen betalning tas idag och slutliga villkor kan gälla.",
    "vibePass.landing.joining": "Registrerar...",
    "vibePass.landing.submit": "Gå med gratis",
    "vibePass.login.eyebrow": "Vibe Pass-pilotåtkomst",
    "vibePass.login.title": "Öppna ditt Vibe Pass",
    "vibePass.login.intro": "Ange din e-post, öppna den säkra länken och slutför incheckningen på plats för att samla Vibe Points.",
    "vibePass.login.email": "E-postadress",
    "vibePass.login.sent": "Säkert åtkomstmeddelande skickat",
    "vibePass.login.checkEmail": "Kontrollera din e-post efter länken till Vibe Pass.",
    "vibePass.login.return": "Öppna länken på den här enheten så återgår du till QR-incheckningen.",
    "vibePass.login.spam": "Ser du den inte? Kontrollera skräppost och använd din registrerade e-post.",
    "vibePass.login.sending": "Skickar säker åtkomst...",
    "vibePass.login.submit": "Begär säker åtkomst",
    "vibePass.login.error": "Vi kunde inte skicka åtkomstmeddelandet. Fråga platsen eller försök igen.",
    "vibePass.login.unconfirmed": "Vi kunde inte bekräfta att mejlet skickades. Kontrollera inkorgen och skräpposten innan du försöker igen.",
    "vibePass.login.back": "Tillbaka till Vibe Pass",
    "vibePass.login.explore": "Fortsätt utforska Vibe2Nite",
    "vibePass.checkin.eyebrow": "Vibe Pass-besök",
    "vibePass.checkin.loadingTitle": "Kontrollerar ditt besök",
    "vibePass.checkin.loading": "Laddar denna Vibe Pass-QR-kod.",
    "vibePass.checkin.successTitle": "Vibe Points tillagda",
    "vibePass.checkin.success": "Du samlade {points} Vibe Points för ditt verifierade besök på {venue}.",
    "vibePass.checkin.balance": "Uppdaterat saldo för Vibe Points: {balance}",
    "vibePass.checkin.duplicateTitle": "Redan incheckad",
    "vibePass.checkin.duplicate": "Du har redan fått Vibe Points för det här besöket.",
    "vibePass.checkin.noExtra": "Inga extra Vibe Points lades till.",
    "vibePass.checkin.loginTitle": "Vibe Pass-inloggning krävs",
    "vibePass.checkin.login": "Ange din e-post, öppna den säkra länken och återvänd hit för att slutföra incheckningen.",
    "vibePass.checkin.unavailableTitle": "QR inte tillgänglig",
    "vibePass.checkin.errorTitle": "Incheckning inte tillgänglig",
    "vibePass.checkin.error": "Denna Vibe Pass-QR-kod är inte tillgänglig. Be personalen om den aktiva QR-koden.",
    "vibePass.checkin.view": "Visa Vibe Pass",
    "vibePass.checkin.about": "Om Vibe Pass",
    "vibePass.checkin.explore": "Utforska Vibe2Nite",
    "vibePass.member.yourPass": "Ditt Vibe Pass",
    "vibePass.member.active": "Aktiv pilotmedlem",
    "vibePass.member.points": "Vibe Points",
    "vibePass.member.usable": "Kan användas hos deltagande platser",
    "vibePass.member.nextAction": "Ditt nästa steg",
    "vibePass.member.rewards": "Belöningar och framsteg",
    "vibePass.member.recent": "Senaste aktivitet",
    "vibePass.member.liveOffers": "Liveerbjudanden",
    "vibePass.member.noOffers": "Inga liveerbjudanden just nu. Nya erbjudanden visas här.",
    "vibePass.member.repeatProgress": "Framsteg för återbesök",
    "vibePass.member.noActivity": "Ingen aktivitet ännu. Skanna en QR-kod hos en deltagande plats för att börja.",
    "vibePass.member.secondary": "Ytterligare information",
    "vibePass.member.settings": "Inställningar och hjälp",
    "vibePass.member.membership": "Medlemsuppgifter",
    "vibePass.member.signOut": "Logga ut",
    "vibePass.offer.live": "Live nu",
    "vibePass.offer.ends": "Slutar {date}",
    "vibePass.offer.terms": "Villkor: {terms}",
    "vibePass.offer.directions": "Vägbeskrivning",
    "vibePass.alerts.title": "Få Vibe Alerts",
    "vibePass.alerts.intro": "Få aviseringar om liveerbjudanden och belöningar från deltagande platser.",
    "vibePass.alerts.destination": "Destination",
    "vibePass.alerts.active": "Vibe Alerts är PÅ i den här webbläsaren.",
    "vibePass.alerts.available": "Vibe Alerts är tillgängliga. Aktivera dem för liveerbjudanden.",
    "vibePass.alerts.blocked": "Aviseringar är blockerade i webbläsarens inställningar.",
    "vibePass.alerts.unsupported": "Vibe Alerts stöds inte på denna webbläsare eller enhet.",
    "vibePass.alerts.ios": "Lägg till Vibe2Nite på hemskärmen för att aktivera Vibe Alerts på iPhone.",
    "vibePass.alerts.enable": "Aktivera Vibe Alerts",
    "vibePass.alerts.enabled": "Alerts aktiverade",
    "vibePass.alerts.save": "Spara inställningar",
    "vibePass.alerts.off": "Stäng av Alerts"
  }
};
